import React, { useState } from "react";
import "./AdventureCabViewMore.css";
import { Link } from "react-router-dom";
import CityCabPrime from "../../assets/CityCabPrime.png";
import EconomySwiftCab from "../../assets/EconomySwiftCab.png";
import LuxuryBMWCab from "../../assets/LuxuryBMWCab.png";
import CityRideCab from "../../assets/CityRideCab.png";
import EconomyUrbanCab from "../../assets/EconomyUrbanCab.png";
import LuxuryAudiCab from "../../assets/LuxuryAudiCab.png";
import CityTravelCab from "../../assets/CityTravelCab.png";
import EconomyBudgetCab from "../../assets/EconomyBudgetCab.png";
import LuxuryMercedesCab from "../../assets/LuxuryMercedesCab.png";
import CityMetroCab from "../../assets/CityMetroCab.png";

import CityDieselCab from "../../assets/CityDieselCab.png";
import EconomyDzireCab from "../../assets/EconomyDzireCab.png";
import LuxuryJaguarCab from "../../assets/LuxuryJaguarCab.png";
import CityComfortCab from "../../assets/CityComfortCab.png";
import EconomyTravelCab from "../../assets/EconomyTravelCab.png";
import LuxuryLexusCab from "../../assets/LuxuryLexusCab.png";
import CityRideDiesel from "../../assets/CityRideDiesel.png";
import EconomyDieselCab from "../../assets/EconomyDieselCab.png";
import LuxuryDieselCab from "../../assets/LuxuryDieselCab.png";
import CityDieselPrime from "../../assets/CityDieselPrime.png";

import MarutiSuzukiSwift from "../../assets/MarutiSuzukiSwift.png";
import Hyundaii20 from "../../assets/Hyundaii20.png";
import HondaCity from "../../assets/HondaCity.png";
import ToyotaCamry from "../../assets/ToyotaCamry.png";
import MarutiBaleno from "../../assets/MarutiBaleno.png";
import HyundaiVerna from "../../assets/HyundaiVerna.png";
import KiaSeltos from "../../assets/KiaSeltos.png";
import TataAltroz from "../../assets/TataAltroz.png";
import SkodaSlavia from "../../assets/SkodaSlavia.png";
import VolkswagenVirtus from "../../assets/VolkswagenVirtus.png";

import MarutiWagonRCNG from "../../assets/MarutiWagonRCNG.png";
import MarutiAltoK10CNG from "../../assets/MarutiAltoK10CNG.png";
import HyundaiSantroCNG from "../../assets/HyundaiSantroCNG.png";
import MarutiDzireCNG from "../../assets/MarutiDzireCNG.png";
import ToyotaGlanzaCNG from "../../assets/ToyotaGlanzaCNG.png";
import TataTiagoCNG from "../../assets/TataTiagoCNG.png";
import HyundaiAuraCNG from "../../assets/HyundaiAuraCNG.png";
import MarutiErtigaCNG from "../../assets/MarutiErtigaCNG.png";
import MarutiCelerioCNG from "../../assets/MarutiCelerioCNG.png";
import TataTigorCNG from "../../assets/TataTigorCNG.png";
import TataNexonEV from "../../assets/TataNexonEV.png";
import MGZSEV from "../../assets/MGZSEV.png";
import HyundaiKonaEV from "../../assets/HyundaiKonaEV.png";
import MahindraXUV400EV from "../../assets/MahindraXUV400EV.png";
import TataTiagoEV from "../../assets/TataTiagoEV.png";
import TataTigorEV from "../../assets/TataTigorEV.png";
import BYDAtto3 from "../../assets/BYDAtto3.png";
import KiaEV6 from "../../assets/KiaEV6.png";
import BMWi4 from "../../assets/BMWi4.png";
import MercedesEQB from "../../assets/MercedesEQB.png";
const cabData = [
  // Petrol (1-10)
  {
    id: 1,
    name: "City Cab Prime",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityCabPrime,
  },
  {
    id: 2,
    name: "Economy Swift Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: EconomySwiftCab,
  },
  {
    id: 3,
    name: "Luxury BMW Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: LuxuryBMWCab,
  },
  {
    id: 4,
    name: "City Ride Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityRideCab,
  },
  {
    id: 5,
    name: "Economy Urban Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: EconomyUrbanCab,
  },
  {
    id: 6,
    name: "Luxury Audi Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: LuxuryAudiCab,
  },
  {
    id: 7,
    name: "City Travel Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityTravelCab,
  },
  {
    id: 8,
    name: "Economy Budget Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: EconomyBudgetCab,
  },
  {
    id: 9,
    name: "Luxury Mercedes Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: LuxuryMercedesCab,
  },
  {
    id: 10,
    name: "City Metro Cab",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityMetroCab,
  },

  // Diesel (11-20)
  {
    id: 11,
    name: "City Diesel Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityDieselCab,
  },
  {
    id: 12,
    name: "Economy Dzire Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: EconomyDzireCab,
  },
  {
    id: 13,
    name: "Luxury Jaguar Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: LuxuryJaguarCab,
  },
  {
    id: 14,
    name: "City Comfort Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityComfortCab,
  },
  {
    id: 15,
    name: "Economy Travel Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: EconomyTravelCab,
  },
  {
    id: 16,
    name: "Luxury Lexus Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: LuxuryLexusCab,
  },
  {
    id: 17,
    name: "City Ride Diesel",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityRideDiesel,
  },
  {
    id: 18,
    name: "Economy Diesel Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: EconomyDieselCab,
  },
  {
    id: 19,
    name: "Luxury Diesel Cab",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: LuxuryDieselCab,
  },
  {
    id: 20,
    name: "City Diesel Prime",
    capacity: "4 Passenger",
    fuel: "Diesel",
    type: "City Cab",
    price: "Rs--/hr",
    image: CityDieselPrime,
  },

  // Petrol Cars (21-30)
  {
    id: 21,
    name: "Maruti Suzuki Swift",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: MarutiSuzukiSwift,
  },
  {
    id: 22,
    name: "Hyundai i20",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: Hyundaii20,
  },
  {
    id: 23,
    name: "Honda City",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: HondaCity,
  },
  {
    id: 24,
    name: "Toyota Camry",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: ToyotaCamry,
  },
  {
    id: 25,
    name: "Maruti Baleno",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "City Cab",
    price: "Rs--/hr",
    image: MarutiBaleno,
  },
  {
    id: 26,
    name: "Hyundai Verna",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: HyundaiVerna,
  },
  {
    id: 27,
    name: "Kia Seltos",
    capacity: "5 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: KiaSeltos,
  },
  {
    id: 28,
    name: "Tata Altroz",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: TataAltroz,
  },
  {
    id: 29,
    name: "Skoda Slavia",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: SkodaSlavia,
  },
  {
    id: 30,
    name: "Volkswagen Virtus",
    capacity: "4 Passenger",
    fuel: "Petrol",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: VolkswagenVirtus,
  },

  // CNG (31-40)
  {
    id: 31,
    name: "Maruti WagonR CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "City Cab",
    price: "Rs--/hr",
    image: MarutiWagonRCNG,
  },
  {
    id: 32,
    name: "Maruti Alto K10 CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: MarutiAltoK10CNG,
  },
  {
    id: 33,
    name: "Hyundai Santro CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: HyundaiSantroCNG,
  },
  {
    id: 34,
    name: "Maruti Dzire CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "City Cab",
    price: "Rs--/hr",
    image: MarutiDzireCNG,
  },
  {
    id: 35,
    name: "Toyota Glanza CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "City Cab",
    price: "Rs--/hr",
    image: ToyotaGlanzaCNG,
  },
  {
    id: 36,
    name: "Tata Tiago CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: TataTiagoCNG,
  },
  {
    id: 37,
    name: "Hyundai Aura CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "City Cab",
    price: "Rs--/hr",
    image: HyundaiAuraCNG,
  },
  {
    id: 38,
    name: "Maruti Ertiga CNG",
    capacity: "6 Passenger",
    fuel: "CNG",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: MarutiErtigaCNG,
  },
  {
    id: 39,
    name: "Maruti Celerio CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: MarutiCelerioCNG,
  },
  {
    id: 40,
    name: "Tata Tigor CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    type: "City Cab",
    price: "Rs--/hr",
    image: TataTigorCNG,
  },
  // Electric Cars (41 - 50)

  {
    id: 41,
    name: "Tata Nexon EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "City Cab",
    price: "Rs--/hr",
    image: TataNexonEV,
  },
  {
    id: 42,
    name: "MG ZS EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: MGZSEV,
  },
  {
    id: 43,
    name: "Hyundai Kona Electric",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: HyundaiKonaEV,
  },
  {
    id: 44,
    name: "Mahindra XUV400 EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "City Cab",
    price: "Rs--/hr",
    image: MahindraXUV400EV,
  },
  {
    id: 45,
    name: "Tata Tiago EV",
    capacity: "4 Passenger",
    fuel: "Electric",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: TataTiagoEV,
  },
  {
    id: 46,
    name: "Tata Tigor EV",
    capacity: "4 Passenger",
    fuel: "Electric",
    type: "Economy Cab",
    price: "Rs--/hr",
    image: TataTigorEV,
  },
  {
    id: 47,
    name: "BYD Atto 3",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: BYDAtto3,
  },
  {
    id: 48,
    name: "Kia EV6",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: KiaEV6,
  },
  {
    id: 49,
    name: "BMW i4",
    capacity: "5 Passenger",
    fuel: "Electric",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: BMWi4,
  },
  {
    id: 50,
    name: "Mercedes EQB",
    capacity: "7 Passenger",
    fuel: "Electric",
    type: "Luxury Cab",
    price: "Rs--/hr",
    image: MercedesEQB,
  },
];

const AdventureCabViewMore = () => {
  const [fuelType, setFuelType] = useState("Petrol");

  const filteredCabs = cabData.filter((cab) => cab.fuel === fuelType);
const getPrice = (type) => {
  if (type === "Economy Cab") return 1100;
  if (type === "City Cab") return 1150;
  if (type === "Luxury Cab") return 1400;
  return 1120;
};
  return (
    <div className="adventure-view-more-cab-page">
      <div className="adventure-view-more-fuel-buttons">
        <button onClick={() => setFuelType("Petrol")} className="petrol-btn">
          Petrol
        </button>
        <button className="diesel-btn" onClick={() => setFuelType("Diesel")}>
          Diesel
        </button>
        <button className="cng-btn" onClick={() => setFuelType("CNG")}>
          CNG
        </button>
        <button
          className="electric-btn"
          onClick={() => setFuelType("Electric")}
        >
          Electric
        </button>
      </div>

      <div className="adventure-view-more-cab-grid">
        {filteredCabs.map((cab) => (
          <Link
            to="/adventure-traveller-detail-page"
            className="view-more-adventure-cab-link"
            state={{
              carData: cab,
              totalPrice: getPrice(cab.type),
            }}
            key={cab.id}
          >
            {" "}
            <div className="adventure-view-more-cab-card" key={cab.id}>
              <div className="adventure-view-more-type-tag">{cab.type}</div>
              <div className="adventure-view-more-price-tag">
                {" "}
                ₹{getPrice(cab.type)}
              </div>

              <div className="adventure-view-more-image-div">
                {" "}
                <img src={cab.image} alt={cab.name} />
              </div>

              <h3>{cab.name}</h3>
              <p>{cab.capacity}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdventureCabViewMore;
